import { render, staticRenderFns } from "./soundEffectPack.vue?vue&type=template&id=12e74d5c&scoped=true"
import script from "./soundEffectPack.vue?vue&type=script&lang=ts"
export * from "./soundEffectPack.vue?vue&type=script&lang=ts"
import style0 from "./soundEffectPack.vue?vue&type=style&index=0&id=12e74d5c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e74d5c",
  null
  
)

export default component.exports